import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FeedbackPanelTablistAriaDirective } from './feedback-panel-tablist-aria.directive';
import { FeedbackPanelTabsComponent } from './feedback-panel-tabs.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FeedbackPanelTablistAriaDirective
	],
	declarations: [
		FeedbackPanelTabsComponent
	],
	exports: [
		FeedbackPanelTabsComponent
	]
})
export class FeedbackPanelTabsModule {}
